import {graphql} from '~/graphql-react-query/';

export const UserList = graphql(`
    query UserListQuery(
        $pagination: UserListPagination
        $orderBy: UserListOrderBy
        $filter: UserListFilter
    ) {
        user {
            userList(pagination: $pagination, orderBy: $orderBy, filter: $filter) {
                id
                username
                name
                status {
                    australianMediaValue
                    australianCreative
                    newZealandCreative
                    adminProducts
                }
                createdAt
                updatedAt
                memberships {
                    teamId
                    team {
                        id
                        name
                    }
                }
            }
        }
    }
`);

export const UserUpdateSessionMetadata = graphql(`
    mutation UserUpdateSessionMetadataMutation($user: UserUpdateSessionMetadataInput!) {
        user {
            userUpdateSessionMetadata(mutation: $user) {
                id
                name
                createdAt
                updatedAt
                phone
            }
        }
    }
`);

export const UserItem = graphql(`
    query UserItemQuery($id: String!) {
        user {
            user(userId: $id) {
                id
                username
                name
                status {
                    australianMediaValue
                    australianCreative
                    newZealandCreative
                    adminProducts
                }
                createdAt
                updatedAt
                memberships {
                    teamId
                    team {
                        id
                        name
                    }
                }
            }
        }
    }
`);

export const ReportChangeOwnership = graphql(`
    mutation ReportChangeOwnershipMutation($input: ReportChangeOwnershipInput!) {
        reportV2 {
            reportChangeOwnership(input: $input) {
                report {
                    id
                    user {
                        id
                        name
                    }
                    teamId
                    teamName
                    name
                    description
                    iconName
                    iconColor
                    sharing {
                        status
                        usersWithAccess {
                            id
                            name
                            email
                        }
                    }
                    createdAt
                    updatedAt
                }
            }
        }
    }
`);

export const SegmentChangeOwnership = graphql(`
    mutation SegmentV2ChangeOwnership($input: SegmentV2ChangeOwnership!) {
        segmentV2 {
            segmentChangeOwnership(input: $input) {
                id
                name
                color
                teamId
                teamName
                description
                definitionV2
                author {
                    id
                    name
                }
                sharing {
                    status
                    usersWithAccess {
                        id
                        name
                    }
                }
                createdAt
                updatedAt
                status
            }
        }
    }
`);
